// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import { EnvironmentConfig } from './environment-config';

export const environment: EnvironmentConfig = {
  production: true,
  variables: {
    exampleVariable: 'example environment variable',
    objectVariable: {
      variable: 'wguVariable',
    },
  },
  featureFlags: {
    exampleFeatureFlag: false,
    feature: false,
  },
  config: {
    auth: {
      clientId: 's2s-myaccount-idapi',
      issuer: 'https://access.dev.wgu.edu/pingfed/',
      redirectUri: 'https://my.dev.wgu.edu/updateAccount'
      // redirectUri: window.location.origin,
    },
    apiUrls: {
      pingService: 'https://access.dev.wgu.edu/pingfed/as/token.oauth2',
    },
    resourceUrls: ['https://access.dev.wgu.edu/pingfed/as/token.oauth2'],
  },
};